export const BG_COLOR = '#C1E9F0'
